export default function goErrorPage(page = 'not-found') {
	const metaRobots = document.createElement('meta')
	metaRobots.name = 'robots'
	metaRobots.content = 'noindex'
	document.head.appendChild(metaRobots)

	const subfix = page === 'not-found' ? '' : `?page=${page}`
	if (!import.meta.env.PROD) {
		window.location.href = `/not-found${subfix}`
	} else {
		window.location.href = `/404${subfix}`
	}
}
